import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const BackButton = ({ position = {}, onBackButton = null }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const positionStyle = {
    position: "absolute",
    ...position,
  };

  const { t } = useTranslation();

  return (
    <div
      className="d-flex flex-row-reverse ms-2 me-2 w-100 pe-2"
      style={positionStyle}
    >
      <Button
        variant="link"
        className="text-decoration-none p-0 text-primary"
        onClick={onBackButton ? onBackButton : handleBack}
        aria-label="Go back to previous page"
        title="Back"
      >
        <i className="fa-solid fa-arrow-left" title="Back"></i> {t("Back")}
      </Button>
    </div>
  );
};

export default BackButton;
